import { SERVER_AI } from '../constants/system.keys';
import { GET_API } from './index';

export const getVirtualWall = async ({ token, dataHeader, dataQuery }) => {
  return GET_API(`${SERVER_AI}/virtualWalls`, token, dataHeader, dataQuery);
};

export const getWeaponDetection = async ({ token, dataHeader, dataQuery }) => {
  return GET_API(`${SERVER_AI}/weaponDetections`, token, dataHeader, dataQuery);
};

export const getSecurityIdentifications = async ({
  token,
  dataHeader,
  dataQuery,
}) => {
  return GET_API(
    `${SERVER_AI}/securityIdentifications`,
    token,
    dataHeader,
    dataQuery
  );
};

export const getHistoryTrackingEvents = async ({
  token,
  dataHeader,
  dataQuery,
}) => {
  return GET_API(`${SERVER_AI}/trackingEvents`, token, dataHeader, dataQuery);
};

export const getEventsByPersonId = async ({ token, dataHeader, dataQuery }) => {
  return GET_API(`${SERVER_AI}/v1/faceid/cdrs`, token, dataHeader, dataQuery);
};
